export default __webpack_public_path__ + "static/media/default-food-type.b863e262.svg";